import TwitterMediaAssetsValidationError from "./error/TwitterMediaAssetsValidationError";
import {FileObject} from "../home/file-upload";
import {Injectable} from "@angular/core";
import {MediaAssetsValidationService} from "./media-assets-validation-service"

@Injectable()
export class TwitterMediaAssetsValidationService extends MediaAssetsValidationService {
  validate(currentUploadedFiles: FileObject[], files: FileList, optionalImageUrl?: string | null) {
    if (!this.isValidImageUrl(optionalImageUrl)) {
      throw new TwitterMediaAssetsValidationError("Please make sure you provided a valid image url on Twitter Image url field.");
    }
    if (!optionalImageUrl && !files) {
      throw new TwitterMediaAssetsValidationError("Please make sure that attached file is not empty");
    }

    const fileLength = (files ? files.length : 0) + (optionalImageUrl ? 1 : 0) + (currentUploadedFiles ? currentUploadedFiles.length : 0);
    if (fileLength > FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER) {
      throw new TwitterMediaAssetsValidationError("A maximum of " + FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER + " images may be attached to a Tweet.");
    }

    // This might be an optional image URI
    if (!files) return;

    let numberOfImages = 0;
    let numberOfGifImages = 0;
    let numberOfVideos = 0;

    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      if (file.type === "image/gif" && (file.size < 0 || file.size > FileObject.TWITTER_MAX_GIF_ALLOWED_SIZE_IN_BYTES)) {
        throw new TwitterMediaAssetsValidationError("Twitter animated GIF size must be <= " + (FileObject.TWITTER_MAX_GIF_ALLOWED_SIZE_IN_BYTES / 1024 / 1024) + " MB");
      }
      if (file.type !== "image/gif" && file.type.indexOf("image") !== -1 && (file.size < 0 || file.size > FileObject.TWITTER_MAX_IMAGE_ALLOWED_SIZE_IN_BYTES)) {
        throw new TwitterMediaAssetsValidationError("Twitter supported image size must be <= " + (FileObject.TWITTER_MAX_IMAGE_ALLOWED_SIZE_IN_BYTES / 1024 / 1024) + " MB");
      }
      if (file.type.indexOf("video") !== -1 && (file.size < 0 || file.size > FileObject.TWITTER_MAX_VIDEO_ALLOWED_SIZE_IN_BYTES)) {
        throw new TwitterMediaAssetsValidationError("Twitter supported video size must be <= " + (FileObject.TWITTER_MAX_VIDEO_ALLOWED_SIZE_IN_BYTES / 1024 / 1024) + " MB");
      }
      if (file.type === "image/gif") {
        numberOfGifImages++;
      } else if (file.type !== "image/gif" && file.type.indexOf("image") !== -1) {
        numberOfImages++;
      } else if (file.type.indexOf("video") !== -1) {
        numberOfVideos++;
      }
    }
    if (currentUploadedFiles && currentUploadedFiles.length > 0) {
      currentUploadedFiles.forEach(_fileObj => {
        let file: File = _fileObj.file;
        if (file && file.type) {
          if (file.type === "image/gif") {
            numberOfGifImages++;
          } else if (file.type !== "image/gif" && file.type.indexOf("image") !== -1) {
            numberOfImages++;
          } else if (file.type.indexOf("video") !== -1) {
            numberOfVideos++;
          }
        }
      })
    }
    if (numberOfImages > FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER) {
      throw new TwitterMediaAssetsValidationError("Twitter max upload image number must not be greater than " + FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER);
    }

    if (numberOfGifImages > FileObject.TWITTER_MAX_ATTACHED_GIF_NUMBER) {
      throw new TwitterMediaAssetsValidationError("Only one animated GIF may be attached to a Tweet.")
    }
    if (numberOfVideos > FileObject.TWITTER_MAX_ATTACHED_VIDEO_NUMBER) {
      throw new TwitterMediaAssetsValidationError("Only one video may be attached to a Tweet.")
    }
    if (numberOfImages === 0 && numberOfGifImages > 0 && numberOfVideos > 0) {
      throw new TwitterMediaAssetsValidationError(
        "You may attach up to " + FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER + " photos, " +
        FileObject.TWITTER_MAX_ATTACHED_GIF_NUMBER + " animated GIF or " + FileObject.TWITTER_MAX_ATTACHED_VIDEO_NUMBER + " video in a Tweet.");
    }
    if (numberOfImages > 0 && (numberOfGifImages > 0 || numberOfVideos > 0)) {
      throw new TwitterMediaAssetsValidationError(
        "You may attach up to " + FileObject.TWITTER_MAX_ATTACHED_IMAGE_NUMBER + " photos, " +
        FileObject.TWITTER_MAX_ATTACHED_GIF_NUMBER + " animated GIF or " + FileObject.TWITTER_MAX_ATTACHED_VIDEO_NUMBER + " video in a Tweet.");
    }
  }
}
